export const latePayment = {
  name: "late-payment" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M1.6 3.5a.9.9 0 0 1 .9-.9h18a.9.9 0 0 1 .9.9V10a.9.9 0 0 1-1.8 0V8.4H3.4v6.2h5.1a.9.9 0 1 1 0 1.8h-6a.9.9 0 0 1-.9-.9v-12Zm1.8 3.1h16.2V4.4H3.4v2.2ZM16 11.9a4.1 4.1 0 1 0 0 8.2 4.1 4.1 0 0 0 0-8.2ZM10.1 16a5.9 5.9 0 1 1 11.8 0 5.9 5.9 0 0 1-11.8 0Zm5.9-2.9a.9.9 0 0 1 .9.9v2.421a.9.9 0 0 1-.14.482l-1 1.579a.9.9 0 1 1-1.52-.964l.86-1.358V14a.9.9 0 0 1 .9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["late-payment"],
  category: "finance" as const,
};
